import axiosInstance from "./axiosInstance";

const supportService = {
  getTickets: async (params = {}) => {
    const res = await axiosInstance.get("/admin/support/tickets", { params });
    return res.data;
  },

  getUnclaimedCount: async () => {
    const res = await axiosInstance.get("/admin/support/tickets/unclaimed-count");
    return res.data;
  },

  getAgentTickets: async ({ agentId, status, search, page = 1, limit = 20, signal } = {}) => {
    const id = Number(agentId);
    if (!Number.isFinite(id) || id <= 0) {
      throw new Error("Invalid agent id");
    }
    const params = { agent_id: id, page, limit };
    if (status) params.status = String(status).trim().toUpperCase();
    if (search) params.search = search;
    const res = await axiosInstance.get("/admin/support/tickets", { params, signal });
    return res.data;
  },

  getTicket: async (id) => {
    const res = await axiosInstance.get(`/admin/support/tickets/${id}`);
    return res.data;
  },

  markTicketSeen: async (id) => {
    const res = await axiosInstance.post(`/admin/support/tickets/${id}/mark-seen`);
    return res.data;
  },

  deleteTicket: async (id) => {
    const res = await axiosInstance.delete(`/admin/support/tickets/${id}`);
    return res.data;
  },

  claimTicket: async (id) => {
    const res = await axiosInstance.post(`/admin/support/tickets/${id}/claim`);
    return res.data;
  },

  assignTicket: async (id, agentId) => {
    const res = await axiosInstance.put(`/admin/support/tickets/${id}/assign`, {
      agent_id: agentId,
    });
    return res.data;
  },

  updateStatus: async (id, status) => {
    const res = await axiosInstance.put(`/admin/support/tickets/${id}/status`, { status });
    return res.data;
  },

  sendMessage: async (id, message) => {
    const res = await axiosInstance.post(`/admin/support/tickets/${id}/message`, { message });
    return res.data;
  },

  sendVoice: async (id, file, voiceMeta) => {
    const form = new FormData();
    const type = file.type || "audio/webm";
    const ext = type.includes("mp4")
      ? "m4a"
      : type.includes("ogg")
        ? "ogg"
        : type.includes("caf")
          ? "caf"
          : "webm";
    form.append("file", file, file.name || `voice.${ext}`);
    const waveform = voiceMeta && voiceMeta.waveform;
    if (Array.isArray(waveform) && waveform.length) {
      form.append("voice_waveform", JSON.stringify(waveform));
    }
    if (voiceMeta && voiceMeta.durationMs) {
      form.append("voice_duration_ms", String(voiceMeta.durationMs));
    }
    const res = await axiosInstance.post(`/admin/support/tickets/${id}/voice`, form);
    return res.data;
  },

  sendImage: async (id, file) => {
    const form = new FormData();
    form.append("file", file);
    const res = await axiosInstance.post(`/admin/support/tickets/${id}/image`, form);
    return res.data;
  },

  sendAttachment: async (id, file) => {
    const form = new FormData();
    form.append("file", file);
    if (file?.name) form.append("filename", file.name);
    const res = await axiosInstance.post(`/admin/support/tickets/${id}/attachment`, form);
    return res.data;
  },

  deleteMessage: async (ticketId, messageId) => {
    const res = await axiosInstance.delete(
      `/admin/support/tickets/${ticketId}/messages/${messageId}`
    );
    return res.data;
  },

  initiateCall: async (id, callType = "voice") => {
    const res = await axiosInstance.post(`/admin/support/tickets/${id}/call/initiate`, {
      call_type: callType,
    });
    return res.data;
  },

  endCall: async (id, callId, durationSeconds = 0) => {
    const res = await axiosInstance.post(`/admin/support/tickets/${id}/call/end`, {
      call_id: callId,
      duration_seconds: durationSeconds,
    });
    return res.data;
  },

  getStats: async () => {
    const res = await axiosInstance.get("/admin/support/stats");
    return res.data;
  },

  getAccess: async () => {
    const res = await axiosInstance.get("/admin/support/access");
    return res.data;
  },

  getPerformance: async (params = {}) => {
    const res = await axiosInstance.get("/admin/support/performance", { params });
    return res.data;
  },

  getTeams: async () => {
    const res = await axiosInstance.get("/admin/support/teams");
    return res.data;
  },

  createTeam: async (payload) => {
    const res = await axiosInstance.post("/admin/support/teams", payload);
    return res.data;
  },

  updateTeam: async (id, payload) => {
    const res = await axiosInstance.put(`/admin/support/teams/${id}`, payload);
    return res.data;
  },

  deleteTeam: async (id) => {
    const res = await axiosInstance.delete(`/admin/support/teams/${id}`);
    return res.data;
  },

  getCsrs: async () => {
    const res = await axiosInstance.get("/admin/support/staff");
    return res.data;
  },

  getStaff: async () => {
    const res = await axiosInstance.get("/admin/support/staff");
    return res.data;
  },

  updateStaffRole: async (userId, support_role) => {
    const res = await axiosInstance.put(`/admin/support/staff/${userId}/role`, { support_role });
    return res.data;
  },

  deleteMessage: async (ticketId, messageId) => {
    const res = await axiosInstance.delete(`/admin/support/tickets/${ticketId}/messages/${messageId}`);
    return res.data;
  },

  createStaffUser: async (payload) => {
    const res = await axiosInstance.post("/admin/support/staff", payload);
    return res.data;
  },
};

export default supportService;
